module.exports = __webpack_public_path__ + "img/Format-summary.c7f13971.svg";